var AC_Automation = {

	version: 1,
	url_base: "",

	whitelist: [
		"list",
		"contact_add",
		"contact_remove",
		"contact_list",
		"contact_view"
	]
		
};

module.exports = AC_Automation;